/* eslint-disable complexity */
import {
  API_GET_REFERRALS_BY_USER_ID_PENDING,
  API_GET_REFERRALS_BY_USER_ID_SUCCESS,
  API_GET_REFERRALS_BY_USER_ID_FAILURE,
  API_ADD_APP_ID_TO_REFERRAL_SUCCESS,
  API_ADD_APP_ID_TO_REFERRAL_FAILURE,
  API_CREATE_REFERRAL_PENDING,
  API_CREATE_REFERRAL_SUCCESS,
  API_CREATE_REFERRAL_FAILURE,
  API_ADD_APP_ID_TO_REFERRAL_PENDING,
  API_GET_USER_REF_BY_PROMO_ID_PENDING,
  API_GET_USER_REF_BY_PROMO_ID_SUCCESS,
  API_GET_USER_REF_BY_PROMO_ID_FAILURE,
  GET_SHORT_URL_REQUEST,
  GET_SHORT_URL_SUCCESS,
  GET_SHORT_URL_FAILURE,
  RESET_SHORT_URL_DATA,
  REFERRAL_BY_APPT_ID_PENDING,
  REFERRAL_BY_APPT_ID_SUCCESS,
  REFERRAL_BY_APPT_ID_FAILURE,
} from '../actions/referrals/types';

export const initialState = {
  error: '',
  loading: true,
  referralList: [],
  userReferrals: [],
  referral: {
    data: {},
    loading: false,
    error: null
  },
  updateRefRes: {},
  shortUrl: {
    data: {},
    loading: false,
    error: null
  },
  referralByApptId: {
    data: {},
    loading: false,
    error: null
  }
};

// eslint-disable-next-line default-param-last
export default function (state = initialState, action) {
  switch (action.type) {
    case API_GET_REFERRALS_BY_USER_ID_PENDING:
      return { ...state, loading: action.isLoading };
    case API_GET_REFERRALS_BY_USER_ID_SUCCESS:
      return { ...state, loading: action.isLoading, referralList: action.payload };
    case API_GET_REFERRALS_BY_USER_ID_FAILURE:
      return { ...state, loading: action.isLoading, error: action.error };
    case API_ADD_APP_ID_TO_REFERRAL_PENDING:
      return { ...state, loading: action.isLoading };
    case API_ADD_APP_ID_TO_REFERRAL_SUCCESS:
      return { ...state, loading: action.isLoading, updateRefRes: action.payload };
    case API_ADD_APP_ID_TO_REFERRAL_FAILURE:
      return { ...state, loading: action.isLoading, error: action.error };
    case API_CREATE_REFERRAL_PENDING:
      return { ...state, referral: { ...state.referral, loading: action.isLoading, error: null } };
    case API_CREATE_REFERRAL_SUCCESS:
      return { ...state, referral: { loading: action.isLoading, data: action.data, error: null } };
    case API_CREATE_REFERRAL_FAILURE:
      return { ...state, referral: { ...state.referral, loading: action.isLoading, error: action.error } };
    case API_GET_USER_REF_BY_PROMO_ID_PENDING:
      return { ...state, loading: action.isLoading };
    case API_GET_USER_REF_BY_PROMO_ID_SUCCESS:
      return { ...state, loading: action.isLoading, userReferrals: action.payload };
    case API_GET_USER_REF_BY_PROMO_ID_FAILURE:
      return { ...state, loading: action.isLoading, error: action.error };
    case GET_SHORT_URL_REQUEST:
      return { ...state, shortUrl: { ...state.shortUrl, loading: action.isLoading, error: null } };
    case GET_SHORT_URL_SUCCESS:
      return { ...state, shortUrl: { loading: action.isLoading, data: action.data, error: null } };
    case GET_SHORT_URL_FAILURE:
      return { ...state, shortUrl: { ...state.shortUrl, loading: action.isLoading, error: action.error } };
    case RESET_SHORT_URL_DATA:
      return { ...state, shortUrl: { ...initialState.shortUrl } };
    case REFERRAL_BY_APPT_ID_PENDING:
      return { ...state, referralByApptId: { ...state.referralByApptId, loading: action.isLoading, error: null } };
    case REFERRAL_BY_APPT_ID_SUCCESS:
      return { ...state, referralByApptId: { loading: action.isLoading, data: action.data, error: null } };
    case REFERRAL_BY_APPT_ID_FAILURE:
      return { ...state, referralByApptId: { ...state.referralByApptId, loading: action.isLoading, error: action.error } };
    default:
      return state;
  }
}
